<template lang="pug">
  #app
    bg-defs
    transition(name="fade")
      vr(v-show="$route.path.match(/stage/)" :current="currentStage")
    transition(name="fade")
      bg(v-if="!$route.path.match(/stage/)")
    transition(name="fade")
      .fixed.z-50.inset-0.overflow-hidden(v-if="loading")
        bg
        .h-full.flex.flex-col.justify-around.items-center.relative
          .mt-auto(class="w-10/12")
            .home-logotype(:class="{animation:loading}")
              img(class="mx-auto ls:hidden" alt="マグロボからの挑戦" src="images/common/home-logotype-sp.png" srcset="images/common/home-logotype-sp@2x.png 2x, images/common/home-logotype-sp@3x.png 3x")
              img(class="mx-auto hidden ls:block" alt="マグロボからの挑戦" src="images/common/home-logotype.png" srcset="images/common/home-logotype@2x.png 2x, images/common/home-logotype@3x.png 3x")
          asset-loader(v-model="loading" class="w-1/2 max-w-sm mx-auto")
          .mt-auto.mb-12(class="w-1/2 ls:w-3/12 mx-auto")
            img.mx-auto(alt="マグロボ" src="images/common/magrobo-logotype.png" srcset="images/common/magrobo-logotype@2x.png 2x, images/common/magrobo-logotype@3x.png 3x")
    .overflow-hidden(v-if="!loading")
      header
        h1.p-4(class="hidden md:block")
          img(alt="マグロボからの挑戦" src="images/common/header-logotype.png" srcset="images/common/header-logotype@2x.png 2x")
      transition(name="slide-down-toggle")
        .nav1.flex.justify-between.items-center.p-4(v-if="currentStage && $route.path.match(/stage/)")
          .stage-name.mr-4(v-html="formatTohtml(currentStage.name)")
          router-link(class="w-24 router-link-ghost" to="/map") MAP
      transition(name="slide-down-toggle")
        .nav2.p-4(v-if="$route.path=='/status'")
          router-link.router-link-icon(:to="$store.state ? $store.state.route.from.path : '/map'")
            v-fa(icon="times")
      transition(:name="transitionName")
        router-view
      transition(name="slide-up-toggle")
        statusBar(v-if="$route.path.match(/map|stage/)")
    vue-progress-bar

</template>

<style lang="sass" scoped>
header
  @apply fixed z-100 top-0 left-0
.nav1
  @apply fixed z-50 top-0 inset-x-0
  @screen md
    @apply left-auto
  ::v-deep
    span
      @apply inline-block
.nav2
  @apply fixed z-50 top-0 right-0
.stage-name
  @apply leading-none
  @screen md
    @apply px-8 py-3 text-center text-sm font-medium rounded-full border
</style>

<script>
import Vr from "@/components/stage/vr";
import Bg from "@/components/frame/bg";
import BgDefs from "@/components/frame/bgDefs";
import statusBar from "@/components/frame/statusBar";
import assetLoader from "@/components/frame/assetLoader";
export default {
  components: {
    Vr,
    BgDefs,
    Bg,
    statusBar,
    assetLoader
  },
  data() {
    return {
      loading: true,
      transitionName: "fade"
    };
  },
  computed: {
    currentStage() {
      return this.$store.getters["stage/current"];
    }
  },
  mounted() {
    this.$Progress.finish();
  },
  created() {
    this.$store.dispatch("magrobo/load");
    this.$Progress.start();
    this.$router.beforeEach((to, from, next) => {
      // hook the progress bar to start before we move router-view
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress;
        this.$Progress.parseMeta(meta);
      }
      this.$Progress.start();

      if (from) {
        // chenge router transition
        switch (to.path) {
          case "/status":
            this.transitionName = "slide-up";
            break;
          case "/map":
            this.transitionName = "slide-down";
            break;
          default:
            this.transitionName = "fade";
        }
        if (from.path === "/") this.transitionName = "fade";
        if (from.path.search(/stage/) > -1) this.transitionName = "fade";
        if (to.path.search(/stage/) > -1) this.transitionName = "fade";
      }

      next();
    });
    this.$router.afterEach(() => {
      this.$Progress.finish();
      if (this.isTouchDevice && window.innerWidth < screen.width) {
        location.reload(false);
      }
    });
  },
  methods: {
    history_back() {
      this.$router.go(-1);
    }
  }
};
</script>
